import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Api from '../../services/Api';
import Functions from '../../services/Functions';

const ListItemEventFinance = ({ id, date, clientName, city, packageOption, guestsCount, totalAmount, expenses, shop, user, createdAt, updatedAt, setLoading, loadEventFinance, isColaborador }) => {
    const [toggleItem, setToggleItem] = useState([]);

    const [stateDate, setStateDate] = useState(date?.substr(0, 10) || "");
    const [stateClientName, setStateClientName] = useState(clientName || "");
    const [stateCity, setStateCity] = useState(city || "");
    const [statePackageOption, setStatePackageOption] = useState(packageOption);
    const [stateGuestsCount, setStateGuestsCount] = useState(guestsCount || 0);
    const [stateTotalAmount, setStateTotalAmount] = useState(totalAmount || 0);
    const [stateExpenses, setStateExpenses] = useState(expenses || []);

    const [totalExp, setTotalExp] = useState(0);
    const isCreate = Number.isInteger(id);
    const userAdmin = user?.admin;

    useEffect(() => {
        let sum = 0;
        stateExpenses.forEach(exp => sum += Number(exp.value || 0));
        setTotalExp(sum);
    }, [stateExpenses]);

    const handleChangeExpense = (index, field, value) => {
        const newExpenses = [...stateExpenses];
        newExpenses[index][field] = field === 'value' ? parseFloat(value) || 0 : value;
        setStateExpenses(newExpenses);
    };

    const addExpense = () => {
        setStateExpenses([...stateExpenses, { name: '', value: 0 }]);
    };

    const removeExpense = (index) => {
        const newExpenses = [...stateExpenses];
        newExpenses.splice(index, 1);
        setStateExpenses(newExpenses);
    };

    async function handleSubmit(e) {
        e.preventDefault();
        if (stateDate && stateClientName && stateCity && statePackageOption) {
            setLoading(true);
            try {
                const route = "/store-event-finance";
                const data = {
                    id: id,
                    date: stateDate,
                    clientName: stateClientName,
                    city: stateCity,
                    packageOption: statePackageOption,
                    guestsCount: stateGuestsCount,
                    totalAmount: stateTotalAmount,
                    expenses: stateExpenses,
                    shop: shop?._id,
                    user: user?._id
                };
                const response = await Api.saveItem(route, data);
                if (response && response?._id) {
                    toast.success("Operação realizada com sucesso!", { position: toast.POSITION.BOTTOM_RIGHT });
                    loadEventFinance();
                    setToggleItem([]);
                } else {
                    toast.error(response?.message || "Falha ao realizar a operação!", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            } catch (error) {
                console.log(error);
                toast.error("Erro na requisição!", { position: toast.POSITION.BOTTOM_RIGHT });
            } finally {
                setLoading(false);
            }
        } else {
            toast.error("(*) Preencha todos os campos obrigatórios!", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    async function handleDelete() {
        if (window.confirm("Deseja realmente excluir este evento?")) {
            setLoading(true);
            try {
                const response = await Api.saveItem('/delete-event-finance', { id: id });
                if (response && response.deletedCount === 1) {
                    toast.success("Evento excluído com sucesso!", { position: toast.POSITION.BOTTOM_RIGHT });
                    loadEventFinance();
                } else {
                    toast.error("Erro ao excluir o evento!", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        }
    }

    return (
        <li className={toggleItem[0] === id ? "itemDashboardList itemDashboardListActive" : "itemDashboardList"}>
            <div className="row headList" onClick={() => { toggleItem[0] !== id ? setToggleItem([id]) : setToggleItem([]) }}>
                <div className="col-10">
                    <span>{stateDate?.substr(0, 10).split('-').reverse().join('/') + ' - ' + stateClientName + ' - R$ ' + Functions.formatMoney(stateTotalAmount)}</span>
                </div>
                <div className="col-2 text-right">
                    <span className={`iconItem ${toggleItem[0] === id ? 'fas fa-angle-up fa-lg ' : 'fas fa-angle-down fa-lg '}`}></span>
                </div>
            </div>
            {toggleItem[0] === id &&
                <>
                    <hr />
                    <form onSubmit={handleSubmit}>
                        <div className="row v-center">
                            <div className="col-12">
                                <div className="row">
                                    <div className="form-group col-12 col-md-4">
                                        <label className="labelInput">Data do Evento: *</label>
                                        <input type="date" className="form-control" value={stateDate} onChange={e => setStateDate(e.target.value)} required />
                                    </div>
                                    <div className="form-group col-12 col-md-4">
                                        <label className="labelInput">Nome do Cliente: *</label>
                                        <input type="text" className="form-control" placeholder="Cliente" value={stateClientName} onChange={e => setStateClientName(e.target.value)} required />
                                    </div>
                                    <div className="form-group col-12 col-md-4">
                                        <label className="labelInput">Cidade: *</label>
                                        <input type="text" className="form-control" placeholder="Cidade" value={stateCity} onChange={e => setStateCity(e.target.value)} required />
                                    </div>

                                    <div className="form-group col-12 col-md-4">
                                        <label className="labelInput">Pacote: *</label>
                                        <select className="form-control" value={statePackageOption} onChange={e => setStatePackageOption(e.target.value)} required>
                                            <option value=""></option>
                                            <option value="Pacote Econômico">Pacote Econômico</option>
                                            <option value="Pacote Parmas">Pacote Parmas</option>
                                            <option value="Pacote Parmas Premium">Pacote Parmas Premium</option>
                                        </select>
                                    </div>
                                    <div className="form-group col-12 col-md-3">
                                        <label className="labelInput">Quantidade Pessoas: *</label>
                                        <input type="number" className="form-control" min="0" value={stateGuestsCount} onChange={e => setStateGuestsCount(e.target.value)} required />
                                    </div>
                                    <div className="form-group col-12 col-md-5">
                                        <label className="labelInput">Valor Total Cobrado (R$): *</label>
                                        <input type="number" step="0.01" min="0" className="form-control" value={stateTotalAmount} onChange={e => setStateTotalAmount(e.target.value)} required />
                                    </div>

                                    <div className="col-12 mt-3">
                                        <h6>Despesas do Evento</h6>
                                        {stateExpenses.map((expense, index) => (
                                            <div key={index} className="row mb-2">
                                                <div className="col-6">
                                                    <input type="text" className="form-control" placeholder="Nome da Despesa" value={expense.name} onChange={e => handleChangeExpense(index, 'name', e.target.value)} required />
                                                </div>
                                                <div className="col-4">
                                                    <input type="number" step="0.01" className="form-control" placeholder="Valor" value={expense.value} onChange={e => handleChangeExpense(index, 'value', e.target.value)} required />
                                                </div>
                                                <div className="col-2 text-right">
                                                    <button type="button" className="btn btn-danger btn-sm" onClick={() => removeExpense(index)}><i className="fa fa-trash"></i></button>
                                                </div>
                                            </div>
                                        ))}
                                        <button type="button" className="btn btn-info btn-sm mt-2" onClick={addExpense}><i className="fa fa-plus"></i> Adicionar Despesa</button>
                                    </div>
                                </div>
                            </div>
                            <hr className="col-12" />
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-6">
                                        <p style={{ marginBottom: 5 }}>TOTAL COBRADO</p>
                                        <p style={{ marginBottom: 5 }}>TOTAL DESPESAS</p>
                                        <h5>LUCRO EVENTO</h5>
                                    </div>
                                    <div className="col-6 text-right">
                                        <p style={{ marginBottom: 5 }}>R$ {Functions.formatMoney(stateTotalAmount)}</p>
                                        <p style={{ marginBottom: 5 }}>R$ {Functions.formatMoney(totalExp)}</p>
                                        <h5>R$ {Functions.formatMoney(stateTotalAmount - totalExp)}</h5>
                                    </div>
                                </div>
                                {!isCreate && <>
                                    <div className="text-center">
                                        <b>{`Lançado por: ${user?.name} em ${new Date(createdAt).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })}`}</b>
                                    </div>
                                    {updatedAt && (createdAt !== updatedAt) &&
                                        <div className="text-center">
                                            <b>{`Atualizado em ${new Date(updatedAt).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })}`}</b>
                                        </div>
                                    }
                                </>}
                            </div>
                            <hr className="col-12" />
                            <div className="col-12 text-right d-flex justify-content-between">
                                {(!isCreate && !isColaborador) ? <button type="button" className="btn btn-danger" onClick={handleDelete}>Excluir</button> : <div></div>}
                                <button type="submit" className="btn btn-default">Salvar</button>
                            </div>
                        </div>
                    </form>
                </>}
        </li>
    );
};

export default ListItemEventFinance;
